import './landing.css'

// Green washes drifting behind a hero — the landing treatment, shared with the
// webhooks signed-out screen so polish to the glow lands in one place. Literal
// alpha colours: these are glows, not fills, and no semantic token resolves to
// a translucent wash.
//
// One canonical blob set; screens choose how many blobs and how tall the wash
// is. The quieter signed-out screen takes the first two.
const GLOW_BLOBS = [
  {
    className: 'landing-glow-a',
    style: {
      top: -180,
      left: '44%',
      width: 580,
      height: 580,
      background:
        'radial-gradient(circle, rgba(18, 224, 145, 0.15), rgba(18, 224, 145, 0) 62%)',
      filter: 'blur(42px)',
    },
  },
  {
    className: 'landing-glow-b',
    style: {
      top: 130,
      left: -200,
      width: 660,
      height: 660,
      background:
        'radial-gradient(circle, rgba(147, 240, 198, 0.2), rgba(147, 240, 198, 0) 60%)',
      filter: 'blur(50px)',
    },
  },
  {
    className: 'landing-glow-c',
    style: {
      top: 30,
      right: -140,
      width: 480,
      height: 480,
      background:
        'radial-gradient(circle, rgba(78, 231, 166, 0.12), rgba(78, 231, 166, 0) 58%)',
      filter: 'blur(38px)',
    },
  },
] as const

export const HeroGlow = ({
  blobCount = GLOW_BLOBS.length,
  height = 720,
}: {
  blobCount?: number
  height?: number
}) => (
  <div
    aria-hidden="true"
    style={{
      position: 'absolute',
      top: 0,
      left: 0,
      width: '100%',
      height,
      overflow: 'hidden',
      pointerEvents: 'none',
    }}
  >
    {GLOW_BLOBS.slice(0, blobCount).map(blob => (
      <div
        key={blob.className}
        className={blob.className}
        style={{ position: 'absolute', borderRadius: '50%', ...blob.style }}
      />
    ))}
  </div>
)
